module.exports = __webpack_public_path__ + "static/media/age_5.5c2b2a00.svg";